import * as React from 'react'
import {createStyles, Icon, Theme, WithStyles, withStyles, Paper} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import Link from 'src/shared/Link/Link'
import {Panel, PanelContent} from 'src/shared/Panel'
import {css} from 'src/conf/style'

const styles = (t: Theme) => createStyles({
  tag: {
    ...css.flexAlCenter,
    '&:not(:last-of-type)': {
      marginBottom: t.spacing.unit,
    }
  },
  tag_i: {
    color: t.palette.text.secondary,
    marginRight: t.spacing.unit,
  },
  body: {
    border: 'none',
  },
  panelContent:{
    padding: '16px !important'
  },
  wpr: {
    ...css.flexAlCenter,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  name: {
    margin: 0,
    fontSize: '1.1rem',
    textTransform: 'uppercase'
  },
  lei: {
    marginBottom: 0,
    fontSize: '0.8rem',
    fontStyle: 'italic'
  },
  first: {
    flexGrow: 1,
    fontSize: 30,
    maxWidth: '50px'
  },
  second: {
    flexGrow: 2,
  },
  third: {
    flexGrow: 1,
    maxWidth: '30px'
  }
})

interface IProps extends WithI18n,
  WithStyles<typeof styles> {
  consumer: any;
}

class ConsumerCard extends React.Component<IProps, any> {

  render() {
    const {consumer, classes} = this.props
    return (
      <Link to={`/ptf/enterprise/${consumer.id}`}>
      <Paper>
        <Panel hoverable className={classes.body}>
          <PanelContent className={classes.panelContent}>
            <div className={classes.wpr}>
              <Icon className={classes.first}>domain</Icon>
              <div className={classes.second}>
                <p className={classes.name}>{consumer.name}</p>
              </div>
              <Icon className={classes.third}>chevron_right</Icon>
            </div>
          </PanelContent>
        </Panel>
        </Paper>
      </Link>
    )
  }
}

export default compose(
  withI18n,
  withStyles(styles),
)(ConsumerCard)




// WEBPACK FOOTER //
// ./src/page/Consumers/ConsumerCard.tsx